import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

export const i18n = new VueI18n({
    locale: 'en',
    messages: {
        en: {
            action: {
                connect: 'This action requires an integration to be connected to your project. Connect your account for this service in Integrations.',
            },
            message: {
                activated: 'Successfully activated.',
                connected: 'Successfully connected.',
                copied: 'Successfully copied.',
                copiedId: 'Successfully copied ID.',
                created: 'Successfully created.',
                deactivated: 'Successfully deactivated.',
                deleted: 'Successfully deleted.',
                disconnected: 'Successfully disconnected.',
                duplicated: 'Successfully duplicated.',
                queued: 'Successfully queued.',
                removed: 'Successfully removed.',
                saved: 'Successfully saved.',
                scheduled: 'Successfully scheduled.',
                sent: 'Successfully sent.',
                started: 'Successfully started.',
                stopped: 'Successfully stopped.',
                subscribed: 'Successfully subscribed.',
                synced: 'Successfully synced.',
                unscheduled: 'Successfully unscheduled.',
                unsubscribed: 'Successfully unsubscribed.',
                updated: 'Successfully updated.',
                verified: 'Successfully verified.',
            },
            campaign: {
                stop: 'Stop the campaign to make updates to it.',
            },
        },
    },
});